import { Routes } from '@angular/router';
import { Welcome } from './pages/welcome/welcome';
import { Signup } from './pages/signup/signup';
import { Home } from './pages/home/home';
import { About } from './pages/about/about';
import { PitchDeck } from './pages/pitch-deck/pitch-deck';
import { Confirmation } from './emails/confirmation/confirmation';
import { Survey } from './pages/survey/survey';
import { Unsubscribe } from './pages/unsubscribe/unsubscribe';
import { AccountLogin } from './pages/account-login/account-login';
import { AccountSignup } from './pages/account-signup/account-signup';
import { AccountVerify } from './pages/account-verify/account-verify';
import { ForgotPassword } from './pages/forgot-password/forgot-password';
import { AccountDashboard } from './pages/account-dashboard/account-dashboard';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { accountAuthGuard } from './shared/account-auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    title: 'Hebern - Quick and easy data encryption, secure from AI.',
  },
  {
    path: 'pitch-deck',
    component: PitchDeck,
    title: 'Pitch Deck - Hebern Data Encryption',
  },
  {
    path: 'signup',
    component: Signup,
    title: 'Sign Up - Hebern Data Encryption',
  },
  {
    path: 'login',
    component: AccountLogin,
    title: 'Log In - Hebern Data Encryption',
  },
  {
    path: 'account/signup',
    component: AccountSignup,
    title: 'Create Account - Hebern Data Encryption',
  },
  {
    path: 'account/verify',
    component: AccountVerify,
    title: 'Verify Account - Hebern Data Encryption',
  },
  {
    path: 'forgot-password',
    component: ForgotPassword,
    title: 'Reset Password - Hebern Data Encryption',
  },
  {
    path: 'account',
    redirectTo: 'account/self-service',
    pathMatch: 'full',
  },
  {
    path: 'account/self-service',
    component: AccountDashboard,
    canActivate: [accountAuthGuard],
    data: { dashboardRole: 'account_self_service' },
    title: 'Self-Service Dashboard - Hebern Data Encryption',
  },
  {
    path: 'account/encryption',
    component: AccountDashboard,
    canActivate: [accountAuthGuard],
    data: { dashboardRole: 'user' },
    title: 'Encryption Dashboard - Hebern Data Encryption',
  },
  {
    path: 'account/admin',
    component: AccountDashboard,
    canActivate: [accountAuthGuard],
    data: { dashboardRole: 'admin' },
    title: 'Admin Dashboard - Hebern Data Encryption',
  },
  {
    path: 'account/resources',
    redirectTo: 'account/admin',
    pathMatch: 'full',
  },
  {
    path: 'account/super-admin',
    redirectTo: 'account/admin',
    pathMatch: 'full',
  },
  {
    path: 'about',
    component: About,
    title: 'About - Hebern Data Encryption',
  },
  {
    path: 'privacy-policy/document',
    component: PrivacyPolicy,
    data: { bareChrome: true },
    title: 'Privacy Policy - Hebern Data Encryption',
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicy,
    title: 'Privacy Policy - Hebern Data Encryption',
  },
  {
    path: 'welcome',
    component: Welcome,
    title: 'Welcome to Hebern Data Encryption',
  },
  {
    path: 'confirmation/:userEmail/:surveyId',
    component: Confirmation,
    title: 'Email Confirmation - Hebern Data Encryption',
  },
  {
    path: 'survey/:id',
    component: Survey,
    title: 'Survey - Hebern Data Encryption',
  },
  {
    path: 'unsubscribe/:userId',
    component: Unsubscribe,
    title: 'Unsubscribe - Hebern Data Encryption',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
